module.exports = __webpack_public_path__ + "img/bills.8b1ca4df.svg";